var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["ui-textarea", _vm.classList], on: { click: _vm.focus } },
    [
      _vm.label
        ? _c("label", [_vm._v("\n    " + _vm._s(_vm.label) + "\n  ")])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "ui-textarea-container",
          style: { height: _vm.height + "px" }
        },
        [
          _c("textarea", {
            ref: "input",
            style: { resize: "none" },
            attrs: {
              autocomplete: _vm.autocomplete,
              placeholder: _vm.placeholder,
              name: _vm.name,
              disabled: _vm.disabled,
              readonly: _vm.readonly,
              maxlength: _vm.maxLength
            },
            domProps: { value: _vm.computedValue },
            on: { focus: _vm.onFocus, blur: _vm.onBlur, input: _vm.onInput }
          })
        ]
      ),
      _vm.computedError && _vm.computedError.length
        ? _c("p", { staticClass: "error" }, [
            _vm._v("\n    " + _vm._s(_vm.computedError) + "\n  ")
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }